export class MeiliSearchError extends Error {
  override name = "MeiliSearchError";
}
